import { Skeleton, Typography } from '@mui/material';
import { CommonCellProps } from './cells.props';

const CompanyNameCell = ({ valuationRow }: CommonCellProps) => {
  if (valuationRow.is_loading_additional_data) {
    return <Skeleton variant="text" width="80%" height={20} />;
  }

  const companyName = valuationRow.company_name || '-';

  return (
    <Typography
      variant="body2"
      sx={{
        display: 'block',
        width: '100%',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
      }}>
      {companyName}
    </Typography>
  );
};

export default CompanyNameCell;
